import logo from './logo.svg';
import './App.css';
import AddTodo from "./../src/components/AddTodo.js";


function App() {
  return (
    <>
    <div className=''>

    <h1 className='text-3xl font-bold text-center mt-10'>Learn about redux toolkit</h1>
    <AddTodo />
    </div>
    </>
  );
}

export default App;
